import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface PublicSetting {
  key: string;
  value: any;
  display_name: string;
  description: string | null;
}

export function usePublicSettings() {
  const { data: settings, isLoading, error } = useQuery({
    queryKey: ['public-settings'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('app_settings')
        .select('key, value, display_name, description')
        .eq('is_public', true);
      
      if (error) throw error;
      return data as PublicSetting[];
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  const getSetting = (key: string, defaultValue?: any) => {
    if (!settings) return defaultValue;
    const setting = settings.find(s => s.key === key);
    return setting?.value ?? defaultValue;
  };

  return {
    settings,
    isLoading,
    error,
    getSetting,
  };
}
